import React from 'react';
import { useIsCustomPlayerEnabled } from '@jwp/ott-hooks-react/src/useAppConfig';

import Player from '../Player/Player';
import CustomPlayer from '../CustomPlayer/CustomPlayer';
import type { CustomPlayerProps } from '../CustomPlayer/CustomPlayer.types';

export type VideoPlayerProps = CustomPlayerProps;

const VideoPlayer: React.FC<VideoPlayerProps> = (props) => {
  const isCustomPlayerEnabled = useIsCustomPlayerEnabled();

  if (isCustomPlayerEnabled) {
    return <CustomPlayer {...props} onClose={props.onClose} />;
  }

  return <Player {...props} />;
};

export default VideoPlayer;
